<script>
    import { mapActions, mapState } from "vuex";
    import { metaInfo } from "@/core/MetaInfo";
    import ApplicationInfo from "@picooc/components/ApplicationInfo";
    import ApplicationFeatures from "@picooc/components/ApplicationFeatures";
    import ApplicationFunctions from "@picooc/components/ApplicationFunctions";
    import ApplicationCatalog from "@picooc/components/ApplicationCatalog";
    import { catalogApplication } from "@picooc/textApplication";

    export default {
        name: "Application",
        components: {
            ApplicationCatalog,
            ApplicationFunctions,
            ApplicationFeatures,
            ApplicationInfo,
        },
        computed: {
            ...mapState("Picooc", ["applicationProducts"]),
        },
        serverPrefetch() {
            return this.getProductsList();
        },
        mounted() {
            if (!this.applicationProducts.length) {
                this.getProductsList();
            }
        },
        methods: {
            ...mapActions("Picooc", ["getCatalogProducts"]),
            getProductsList() {
                return this.getCatalogProducts({
                    listIds: [...catalogApplication.wifi, ...catalogApplication.bluetooth],
                    type: "application",
                });
            },
        },
        metaInfo() {
            return metaInfo.getMeta("application");
        },
    };
</script>

<template>
    <div class="application">
        <div class="l-container">
            <application-info
                title="Бесплатное приложение Picooc для iOS и&nbsp;Android"
            ></application-info>

            <application-features></application-features>
            <application-functions></application-functions>
            <application-info
                type="sync"
                title="Синхронизация с&nbsp;Apple Health и&nbsp;Google Fit"
            ></application-info>
            <application-catalog :products="applicationProducts"></application-catalog>
        </div>
    </div>
</template>

<style lang="scss">
    .application {
        padding-bottom: 60px;
        margin: 0 auto;
        @include bp($bp-desktop-sm) {
            padding-bottom: 100px;
        }
    }

    .application__section {
        margin: 40px 0;
        padding: 16px;
        border-radius: 20px;
        &:first-child {
            margin-top: 30px;
        }
        @include bp($bp-desktop-sm) {
            margin: 56px 0;
            padding: 40px;
            border-radius: 25px;
            &:first-child {
                margin-top: 40px;
            }
        }
    }
</style>
